import { Box, Card, CardContent, styled, Typography } from '@mui/material';

export const PaymentAndCoverageStyled = styled(Card)(({ theme }) => ({
  display: 'flex',
  boxShadow: 'none',
  border: `0.1rem solid ${theme.palette.grey[200]}`,
})) as typeof Card;

export const NarrowBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '45%',
});

export const WiderBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '55%',
});

export const InlineBoxStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});

export const CurrencyLabelStyled = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  paddingTop: theme.spacing(1),
  fontSize: '1.9rem',
})) as typeof Typography;

export const CenterAlignedLabelStyled = styled(Typography)({
  textAlign: 'center',
  textTransform: 'lowercase',
}) as typeof Typography;

export const CenterAlignedFontLabelStyled = styled(Typography)({
  textAlign: 'center',
  fontSize: '2.8rem',
}) as typeof Typography;

export const CardContentStyled = styled(CardContent)({
  '&:last-child': {
    paddingBottom: 0,
  },
});
